import { createContext, useContext } from 'react';

type MeetingAnalyzeContextProps = {
  meetingsAnalyzeStatus: Record<string, boolean>;
  setMeetingsAnalyzeStatus?: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
};

export const MeetingAnalyzeContext = createContext<MeetingAnalyzeContextProps>({
  meetingsAnalyzeStatus: {},
  setMeetingsAnalyzeStatus: () => undefined
});

export const useMeetingAnalyzeContext = () => useContext(MeetingAnalyzeContext);
